// extracted by mini-css-extract-plugin
module.exports = {"cabecalho":"ConfiguracaoLivre_cabecalho__1YmoU"};